

import { Avatar, Box, Typography, alpha } from "@mui/material";
import { styled } from "@mui/material/styles";
import theme, { palette, shadows, typography, mobileTypography } from "src/config/theme";
export const FooterContainer = styled(Box)({
    width: '100%',
    height: '92px',
    position: 'fixed',
    bottom: 0,
    background: palette.gery.white,
    borderTop: `1px solid ${alpha(palette.gery.black, 0.1)}`,
    boxShadow: shadows[4],
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0 10px'
})

export const IconContainer = styled(Avatar)({
    width: '40px',
    height: '40px',
    border: `1px solid  ${palette.primary.light1}`,
    boxShadow: shadows[1],
    padding: '10px',
    backgroundColor: palette.primary.light3,
    cursor: 'pointer',
    color: palette.primary.main
})

export const ClinicContainer = styled(Box)({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    border: `1px solid ${alpha(theme.palette.gery.black, 0.14)}`,
    borderRadius: '12px',
    minWidth: '189.5px',
    height: '40px',
    boxShadow: theme.shadows[1],
    padding: '10px 12px'

})
export const ClinicInner = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    gap: '6px',

    // position: 'relative'
})
export const OpenCloseText = styled(Typography)({
    ...mobileTypography.h6,
    textWrap: 'nowrap',
    color: palette.gery.black
});
export const SecContainer = styled(Box)({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '10px'
})

export const BackContainer = styled(Avatar)({
    width: '40px',
    height: '40px',
    padding: '10px',
    border: `1px solid ${palette.primary.light1}`,
    backgroundColor: palette.primary.light3,
    boxShadow: shadows[1],
    color: palette.primary.main
})






